export const HOURLY_RATE_GBP = 40;
export const WEBCODECRAFT_MONTHLY_GBP = 49;

export function upfrontForSetup(setup) {
  switch (setup) {
    case 'diy':
      return 800;
    case 'agency':
      return 4500;
    case 'nothing':
      return 2500;
    default:
      return 2500;
  }
}

export function hoursPerMonthForFiddle(fiddle) {
  switch (fiddle) {
    case '0':
      return 0;
    case '1-3':
      return 2;
    case '5+':
      return 5;
    default:
      return 2;
  }
}

export function speedFactor(speed) {
  switch (speed) {
    case 'fast':
      return 0.75;
    case 'slow':
      return 1.35;
    case 'unsure':
      return 1.15;
    default:
      return 1.15;
  }
}

export function monthlyLostLeadValue(customerValueGbp, speed) {
  const base = Math.max(30, Math.round(customerValueGbp * 0.06));
  return Math.round(base * speedFactor(speed));
}

export function calculateWebsiteTax({
  setup,
  fiddle,
  speed,
  customerValueGbp,
  monthlyFeeGbp = WEBCODECRAFT_MONTHLY_GBP
}) {
  const U = upfrontForSetup(setup);
  const T = hoursPerMonthForFiddle(fiddle);
  const H = HOURLY_RATE_GBP;
  const L = monthlyLostLeadValue(customerValueGbp, speed);

  const burnoutAnnual = T * H * 12;
  const performanceAnnual = L * 12;
  const statusQuoYear1 = U + burnoutAnnual + performanceAnnual;
  const webcodecraftYear1 = monthlyFeeGbp * 12;
  const websiteTax = Math.max(0, statusQuoYear1 - webcodecraftYear1);

  return {
    U,
    T,
    H,
    L,
    burnoutAnnual,
    performanceAnnual,
    statusQuoYear1,
    webcodecraftYear1,
    websiteTax,
    savingsVsWcc: statusQuoYear1 - webcodecraftYear1
  };
}

export function reinvestInsight(upfrontGbp, roas) {
  if (!roas || roas <= 0) return 0;
  return Math.round(upfrontGbp * roas);
}
